<div *ngIf="dSS.dienststelle && dSS.modusErweitert" class="ride-group">
  <ion-row>
    <ion-col>
      <h3>Beschäftigungsmerkmale</h3>
    </ion-col>
  </ion-row>
</div>
<ion-row>
  <ion-col size="12">
    <ion-item lines="inset">
      <ion-select
        label="Art der Beschäftigung"
        interface="popover"
        [(ngModel)]="dSS.bArt"
        (ionChange)="update($event, true)"
        [disabled]="!!dSS.dienststelle?.disabledBArt"
      >
        <ion-select-option
          *ngFor="let option of bArtList"
          [value]="option.value"
        >
          {{ option.display }}
        </ion-select-option>
      </ion-select>
    </ion-item>
  </ion-col>
</ion-row>

<ion-row>
  <ion-col>
    <ion-item lines="inset">
      <ion-input
        label="Bruttomonatsentgelt"
        labelPlacement="floating"
        type="number"
        pattern="\d+(\.\d{1,2})?"
        [min]="1"
        [(ngModel)]="dSS.bruttogehalt"
        (ionChange)="update($event)"
        placeholder="Angabe erforderlich!"
        [required]="true"
      >
        <ion-icon
          *ngIf="dSS.bruttogehalt"
          name="logo-euro"
          class="eur_logo__position"
        ></ion-icon>
      </ion-input>
    </ion-item>
    <ion-icon *ngIf="dSS.dsCode.toLowerCase() === 'aok-1223'"
      class="info_icon_select__position"
      name="information-circle-outline"
      (click)="dSS.showDiv('Bruttogehalt')"
    >
    </ion-icon>
    <div *ngIf="dSS.currInfo === 'Bruttogehalt'">
      <p class="RIDE-info">
        ist gleich Steuerbrutto aus regelm. Gehaltsabrechnung
        Arbeitgeberin.
      </p>
    </div>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <ion-list>
      <ion-item lines="inset">
        <ion-select
          label="Steuerklasse"
          interface="popover"
          [(ngModel)]="dSS.stKlasse"
          (ionChange)="update($event)"

        >
          <ion-select-option *ngFor="let option of stKList" [value]="option">
            {{ option }}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
  </ion-col>
</ion-row>
<ng-container *ngIf="dSS.modusErweitert">
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Kinderfreibetrag"
            interface="popover"
            [(ngModel)]="dSS.kinderValue"
            (ionChange)="update($event)"
          >
            <ion-select-option
              *ngFor="let option of kinderList"
              [value]="option"
            >
              {{ option == 6 ? "6+" : option }}</ion-select-option
            >
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Kirchensteuer"
            interface="popover"
            [(ngModel)]="dSS.kircheValue"
            (ionChange)="update($event)"
          >
            <ion-select-option
              *ngFor="let option of JaNeinList"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Bundesland"
            interface="popover"
            [(ngModel)]="dSS.dienststelle.bundesland"
            (ionChange)="update($event)"
            [disabled]="dSS.dienststelle.disabledBundesland"
          >
            <ion-select-option
              *ngFor="let option of bundesl"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Rentenversicherungspflicht"
            interface="popover"
            [(ngModel)]="this.dSS.rvValue"
            (ionChange)="update($event)">
            <ion-select-option
              *ngFor="let option of JaNeinList"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-list>
        <ion-item lines="inset">
          <ion-select
            label="Krankenversicherung"
            interface="popover"
            [(ngModel)]="dSS.kvValue"
            (ionChange)="update($event)"
          >
            <ion-select-option
              *ngFor="let option of kvList"
              [value]="option.value"
            >
              {{ option.display }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-list>
    </ion-col>
  </ion-row>
  <ng-container *ngIf="dSS.kvValue === 'gkv'">
    <ion-row>
      <ion-col>
        <ion-item lines="inset">
          <ion-input
            label="Regelsatz Krankenversicherung %"
            labelPlacement="floating"
            type="number"
            pattern="\d+(\.\d{1,2})?"
            [(ngModel)]="dSS.rsValue"
            (ionChange)="update($event)"
            placeholder="Angabe erforderlich!"
            [required]="true"
          >
          </ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-item lines="inset">
          <ion-input
            label="Zusatzbeitrag Krankenversicherung %"
            labelPlacement="floating"
            type="number"
            pattern="\d+(\.\d{1,2})?"
            [(ngModel)]="dSS.zusatzValue"
            (ionChange)="update($event)"
            placeholder="Angabe erforderlich!"
            [required]="true"
          >
          </ion-input>
        </ion-item>
        <ion-icon *ngIf="dSS.isVivantes()"
                  class="info_icon_select__position"
                  name="information-circle-outline"
                  (click)="dSS.showDiv('zKVInfoViv')"
        >
        </ion-icon>
        <div *ngIf="dSS.currInfo === 'zKVInfoViv'">
          <p class="RIDE-info">
            Der von den gesetzlichen Krankenkassen abhängige Zusatzbeitrag, den das Gesundheitsministerium für das Jahr 2024 mit durchschnittlich 1,7 Prozent angesetzt hat.
          </p>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-list>
          <ion-item lines="inset">
            <ion-select
              label="Sind 23 Jahre oder älter?"
              interface="popover"
              [(ngModel)]="dSS.olderThan23"
              (ionChange)="update($event)"
            >
              <ion-select-option
                *ngFor="let option of JaNeinList"
                [value]="option.value"
              >
                {{ option.display }}
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="dSS.olderThan23">
      <ion-col>
        <ion-list>
          <ion-item lines="inset">
            <ion-select
              label="Anzahl Kinder < 25 Jahre"
              interface="popover"
              [(ngModel)]="dSS.anzahlKinder"
              (ionChange)="update($event)"
            >
              <ion-select-option
                *ngFor="let option of anzahlKinderList; let i = index"
                [value]="option"
              >
                {{ option }}
                <span *ngIf="option === 5">+</span>
              </ion-select-option>
            </ion-select>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
  </ng-container>
  <ng-container *ngIf="dSS.kvValue !== 'gkv'">
    <ion-row>
      <ion-col>
        <ion-item lines="inset">
          <ion-input
            label="Beitrag private Kranken- und Pflegeversicherung"
            labelPlacement="floating"
            type="number"
            pattern="\d+(\.\d{1,2})?"
            [(ngModel)]="dSS.pkvValue"
            (ionChange)="update($event)"
          >
            <ion-icon
              *ngIf="false"
              name="logo-euro"
              class="eur_logo__position"
            ></ion-icon>
          </ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-item lines="inset">
          <ion-input
            label="AG-Anteil private Kranken- und Pflegeversicherung"
            labelPlacement="floating"
            type="number"
            pattern="\d+(\.\d{1,2})?"
            [(ngModel)]="dSS.pvAnteil"
            (ionChange)="update($event)"
          >
            <ion-icon
              *ngIf="false"
              name="logo-euro"
              class="eur_logo__position"
            ></ion-icon>
          </ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
  </ng-container>
 <!-- FIXME a better way to hidde VBL without writting dsCodes in the condition -->
  <ion-row  *ngIf="dSS.dsCode.toLowerCase() !== 'aok-1223' && dSS.bArt !== 2">
    <ion-col>
      <ion-item lines="inset">
        <ion-input
          label="Arbeitnehmeranteil Zusatzversorgung (bspw. VBL) %"
          labelPlacement="floating"
          type="number"
          [step]="0.01"
          [pattern]="'^[0-9]{1,4}([,.][0-9]{1,4})?$'"
          [(ngModel)]="dSS.dienststelle.VBL"
          [disabled]="dSS.dienststelle.disabledVBL"
          (ionChange)="update($event)"
        >
        </ion-input>
      </ion-item>
    </ion-col>
  </ion-row>
</ng-container>
